// import { Zeus } from "./zeus.models";

export interface Product {
	uid: ProductType;
	displayOrder?: number;
	productName?: string;
	productType?: string;
	productIcon?: string;
	productNote?: string;
	price?: string;
	priceUnit?: string;
	pricePrefixText?: string;
	priceFeatures?: string[];
	productFeatures?: string[];
	fibreServiceType?: any; // Zeus.FiberServiceType;
	moreInfo?: MoreInfo;
	serviceType?: string;
	serviceDescription?: string;
}

export interface MoreInfo {
	displayText: string;
	url: string;
}

export enum ProductType {
	InternetNBN = "internet-nbn",
	InternetADSL = "internet-adsl",
	ElectricityAndGas = "electricity-and-gas",
	Electricity = "electricity",
	Gas = "gas",
	Mobile = "mobile",
	InternetOpNBN = "internet-op-nbn"
}

export enum ProductTypeEnum {
	ADSL = "1",
	TelstraCombo = "2",
	NBN = "3",
	ULLCombo = "4",
	EnergyBundle = "5",
	Mobile = "6",
	ADSLWithFetch = "7",
	TelstraComboWithFetch = "8",
	NBNWithFetch = "9",
	Electricity = "10",
	Gas = "11",
	WirelessPostPaid = "12"
}

export interface ProductDiscount {
	monthlySaveAmount?: number;
	yearlySaveAmount?: number;
	monthlySaveDescription?: string;
	yearlySaveDescription?: string;
}

export interface ProductsTexts {
	nbnReady?: string;
	adslReady?: string;
	electricityAndGasAvailable?: string;
	electricityAvailable?: string;
	electricityNotAvailable?: string;
	secondaryNoteWithNoProductsSelected?: string;
	secondaryNoteWithProductsSelected?: string;
	availabilityOfOtherProducts?: string;
	nbnServiceDescription?: string;
	addAService?: string;
}
